import React, { Component } from 'react';
import CardView from './cardTypes/CardView/index';
import CardHighlight from './cardTypes/CardHighlight/index';
import CardTalents from './cardTypes/CardTalents/index';
import CardMatches from '../../mundial/RibbonTypes/CardsTypesMundial/MatchesCard/index';
import CardPlayer from '../../mundial/RibbonTypes/CardsTypesMundial/PlayersCard/index';
import FakeLink from '../FakeLink';
import focusSetting from '../Focus/settings';
import CardHelper from './helpers';
import './card.scss';
import {
    CLASSIC,
    HIGHLIGHT,
    PREMIUM,
    TALENTS,
    RECORDINGS,
    MOREPOPULAR,
    MORETOP,
    INFINITE,
    LIVECHANNEL,
    VOID,
    MUNDIALSOCCERMATCHER,
    MUNDIALPLAYERS,
    SUPERDESTACADO,
    SUPERDESTACADOS,
    LASTVIEWEDCHANNELS,
    UNLINKED,
    PENDING,
    QR_ACTIVATION_CONFIG_HBO_DEFAULT,
    HBO_SUBSCRIPTION,
    HBO_ACTIVATION_MODAL_DELAY_MS,
    LIVEEVENTSCHANNELS
} from '../RibbonNew/constants';
import CardRecording from './cardTypes/CardRecording';
import CardPremium from './cardTypes/CardPremium';
import CardMorePopular from './cardTypes/CardMorePopular';
import CardTop from './cardTypes/CardTop';
import CardInfinite from './cardTypes/CardInfinite';
import CardLiveChannel from './cardTypes/CardLiveChannel';
import CardVoid from './cardTypes/CardVoid';
import Utils, {getNavDataNodeByCode, getNavDataNodeById, getContentAvailability} from '../../utils/Utils';
import { MODAL_RECORD_SERIES_CONTENT, MODAL_TALENT_CONTENTS, showModal, AAF_MODAL_INICIAL_ACTIVA_HBO_MAX } from '../../actions/modal';
import { changeDateToUserRegion } from 'src/mundial/requests/utils';
import store from '../../store';
import { sendGAEvent } from 'src/utils/analytics';
import {GA4} from 'src/utils/trackers/GA4';
import {CONTENT_TYPE_MOVIE, CONTENT_TYPE_SERIE, CONTENT_TYPE_TV,
        CONTENT_SECTION_ADDON, CONTENT_SECTION_SUBCATEGORY, CONTENT_SECTION_ADDON_SUBCATEGORY, CONTENT_SECTION_SUBCATEGORY_TALEN, CONTENT_SECTION_VCARD} from 'src/utils/trackers/GA4Constants';
import {applyOutLineFocus, isActiveFocusDynamic} from "../Focus/utils";
import { SetValueElementMouseEnter } from '../../components/PersistentMiniEpg/MiniObserver';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import CardLastViewedChannel from './cardTypes/CardLastViewedChannel';
import CardLiveEventsChannels from './cardTypes/CardLiveEventsChannels';
import { getStatusHBOCard } from './utils';
import { sendMetricSelectContentHBO } from './utils';
import { setPendingContinueWatchingPlayback, trackContinueWatchingItemClicked } from '../../services/datadog/continueWatching';

import logger from 'src/utils/logger/logger';

class Card extends Component {
    constructor(props) {
        super(props);
        this.getLinkEnvelope = this.getLinkEnvelope.bind(this);
        this.infiniteCardEnvelope = this.infiniteCardEnvelope.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.init = this.init.bind(this);
        this.getClassNumberTop = this.getClassNumberTop.bind(this);
        this.getLastFocus = this.getLastFocus.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this._handleLinkFocus = this._handleLinkFocus.bind(this);
        this._handleLinkKeyDown = this._handleLinkKeyDown.bind(this);
        this._handlePlayerClick = this._handlePlayerClick.bind(this);
        this._handlePlayerFocus = this._handlePlayerFocus.bind(this);
        this._handlePlayerKeyDown = this._handlePlayerKeyDown.bind(this);

        this.init(props);
        this.state = {
            positionInfinite: props.positionInfinite,
            showActions: false,
        };

        this.groupId = props.groupId;

        this.enableModalHBO = Utils.getRegionaliazedMetadata('wbd_hbo_max_activation_linkage_enabled');
        this.qrActivationConfigHBO = Utils.getRegionaliazedMetadata('qr_activation_config', QR_ACTIVATION_CONFIG_HBO_DEFAULT);
    }

    init(props) {
        /**
         * Por el momento el onclick se usa sólo para card tipo livechannel y es en conjunto con
         * el typeRender='a' (ver RibbonLiveChannel)
         */
        this.onClick = props.onClick ? props.onClick : null;
        this.typeRender = props.typeRender;
        this.id = props.id;
        this.focusUp = props.focusUp;
        this.focusDown = props.focusDown || null;
        this.focusRight = props.focusRight;
        this.focusLeft = props.focusLeft;
        this.focusHandler = props.focusHandler;
        this.data = props.data || {};
        this.data.api = props.api;
        this.keyUpHandler = props.keyUpHandler;
        this.keyDownHandler = props.keyDownHandler;
        this.deleteAction = props.deleteAction;
        this.focusClassName = props.focusable ? focusSetting.className : focusSetting.nonfocusable;
        this.onLoadHandler = props.onLoadHandler;
        this.group_name = props.group_name;
        const hasZoomEfectActive = Utils.getApaMetadataKey(
            'aaf_effects_ribbons',
            '{"enable":false}',
            'enable'
        );
        this.zoomEfectClassName = hasZoomEfectActive ? 'link-zoom' : '';
        this.changeFontWeight = window.location.pathname.includes('vcardmatch');

        if (this.props.type !== VOID  &&  (this.props.type !== MUNDIALSOCCERMATCHER) && this.props.type !==  MUNDIALPLAYERS) {
            if (props.data && props.data.ads === 'app_behaviour') {
                this.linkTo = props.data.href;
            } else {
                this.linkTo = CardHelper.getUri(
                    props.href,
                    props.group_id,
                    props.data,
                    props.ignoreSeenLast
                );
            }
            this.linkTo = this.linkTo.indexOf('/') > 0 ? `/${this.linkTo}` : this.linkTo;
        } else if(this.props.type === MUNDIALSOCCERMATCHER || this.props.type ===  MUNDIALPLAYERS){
            this.linkTo = props.href;
        }
    }

    onFocus() {
        if (
            (this.props.type === CLASSIC ||
                this.props.type === RECORDINGS ||
                this.props.type === LIVECHANNEL) &&
            !this.state.showActions
        ) {
            this.setState({ showActions: true });
        }
    }

    onBlur() {
        if (
            (this.props.type === CLASSIC ||
                this.props.type === RECORDINGS ||
                this.props.type === LIVECHANNEL) &&
            this.state.showActions
        ) {
            if (Utils.isModalHide() || Utils.modalType() === MODAL_RECORD_SERIES_CONTENT) {
                this.setState({ showActions: false });
            }
        }
    }

    getLastFocus = ()=>{
      const lastFocus = document.activeElement.getAttribute('id');
      return `#${lastFocus}`;
    }

    isHBOv2Provider = (data) => {
      return Boolean(data) && data.provider === 'hbov2';
    }

    isHBOProvider = (data) => {
        return Boolean(data) && data.provider === 'hbo';
    }

    hasHBOSubscription = (user) => {
        return Array.isArray(user.superhighlight) && user.superhighlight.includes(HBO_SUBSCRIPTION);
    }

    resolveHBOActivationStatus = async (user) => {
        let statusHBO = user.statusHBO;
        let showActivationModalHBO = user.showActivationModalHBO;
        const hboStatus = await getStatusHBOCard();
        if (hboStatus && typeof hboStatus.showActivationModalHBO === 'boolean') {
            statusHBO = hboStatus.statusHBO;
            showActivationModalHBO = hboStatus.showActivationModalHBO;
        }
        return { statusHBO, showActivationModalHBO };
    }

    shouldShowHBOActivationModal = ({ statusHBO, showActivationModalHBO }) => {
        return showActivationModalHBO && (statusHBO === UNLINKED || statusHBO === PENDING);
    }

    handleOnClick = async (e) => {
        localStorage.setItem('lastFocusRecord', this.getLastFocus());
        const {data, title} = this.props;
        const {href} = data;
        const isMundial = href ? href.includes('mundial2022_partidos') : false;

        if (this.props && this.props.isRecentActivity) {
            setPendingContinueWatchingPlayback({
                ribbon: {
                    id: this.props.ribbonId,
                    title: this.props.ribbonName,
                },
                card: this.props.data,
            });
        }

        if (this.props && this.props.isRecentActivity) {
            setPendingContinueWatchingPlayback({
                ribbon: {
                    id: this.props.ribbonId,
                    title: this.props.ribbonName,
                },
                card: this.props.data,
            });
        }

        isMundial && sendGAEvent({
            hitType: 'event',
            eventCategory: 'carruseles inicio',
            eventAction: 'superdestacados',
            eventLabel: title
        });

        // Valida que se seleccionó Banner de HBO Max del carrusel de Superdestacado.
        const isProviderHBOv2 = this.isHBOv2Provider(data);
        const isProviderHBO = this.isHBOProvider(data);
        // Valida que se seleccionó HBO Max del carrusel de PREMIUN.
        const isHrefHBOFromPremium = href === '/node/pandg_hbov2';
        const isLive = data && data.live_enabled && data.live_enabled === "1"

        const { user = {} } = store.getState() || {};
        let statusHBO = user.statusHBO;
        let showActivationModalHBO = user.showActivationModalHBO;

        const isProfileAdmin = Boolean(user.admin);

        if (isProviderHBOv2 && this.hasHBOSubscription(user) && isProfileAdmin) {
            ({ statusHBO, showActivationModalHBO } = await this.resolveHBOActivationStatus(user));
        }

        const showHBOModal = this.shouldShowHBOActivationModal({ statusHBO, showActivationModalHBO });

        if ((isHrefHBOFromPremium || isProviderHBO || isProviderHBOv2) && !isLive && showHBOModal) {
            sendMetricSelectContentHBO(this.props.data);

            // Muestra modal inicial de HBO Max sobre la sección de HBO Max.
            const modal = {
                modalType: AAF_MODAL_INICIAL_ACTIVA_HBO_MAX,
                modalProps: {
                    data
                }
            };
            if (isProviderHBO) {
                setTimeout(() => {
                    store.dispatch(showModal(modal));
                }, HBO_ACTIVATION_MODAL_DELAY_MS);
            } else {
                store.dispatch(showModal(modal));
            }
        }

        this.onClick(e);
        this.sendGA4Metric();
        this.sendDataDogWatchingItem(this.props);
    }

    sendDataDogWatchingItem(props) {
        if(props && typeof props.ribbonId === 'string' && props.ribbonId.toLowerCase() === 'actividadreciente') {
            trackContinueWatchingItemClicked({
                group_id: props.group_id,
                title: props.title,
                source: props.ribbonId,
            });
        }
    }

    sendGA4Metric(){
        let content_list = "", content_name = "";
        const {data, data: {group_id, format_types, provider}, title, ribbonName} = this.props;
        const content_section = this.getContentSection();

        if (content_section === CONTENT_SECTION_SUBCATEGORY_TALEN) {
            content_list = title; //Nombre del Talento
            content_name = data.content_name; //Nombre de la Pelicula

        } else {
            content_list = ribbonName || '';
            content_name = title;
        }

        const gA4 = new GA4();
        const content_id = group_id;
        const content_type = this.getContentType(data);
        const content_category = '';
        const content_availability = getContentAvailability(format_types, provider);
        const isSeries =  this.props &&  this.props.data &&  this.props.data.data &&  this.props.data.data.is_series && this.props.data.data.is_series || this.props &&  this.props.data &&  this.props.data &&  this.props.data.is_series && this.props.data.is_series;
        const indexCard = this.props && this.props.data && this.props.data.index !== undefined ? this.props.data.index : null;
        const indexSerie = this.props && this.props.dataMetric && this.props.dataMetric.cardPosition !== undefined ? this.props.dataMetric.cardPosition : null;
        const content_position = !isSeries ?  indexCard : indexSerie;

        if((content_list.toLowerCase() === SUPERDESTACADO || content_list.toLowerCase() === SUPERDESTACADOS) && isSeries){
            DeviceStorage.setItem('position_card_superdestacados_selected', content_position);
        } else {
            gA4.sendSelectContentEvent(content_section, content_list, content_id, content_name, content_type, content_category, content_availability, content_position);
        }
    }

    getAppBehaviourLayOut(app_behaviour){
        let returnValue = false;
        try {
            const parsedData = JSON.parse(app_behaviour);
            if (parsedData && parsedData.layout !== undefined && parsedData.layout !== null) {
                returnValue = parsedData.layout;
            }
        } catch (ex) {
            logger.error(ex);
        }
        finally{
            return returnValue;
        }
    }

    getContentSection(){
        const ADDON_LAYOUT = 'playandgo';
        let node = {};
        const pathItems = window.location.pathname.split('/');
        if (pathItems.length>0){
            node = pathItems.pop();
            node = getNavDataNodeByCode(node)
        }
        if (node){
            const {text, level, app_behaviour} = node;
            let appBehaviour = this.getAppBehaviourLayOut(app_behaviour)
            if (level === 1) {
                return `home ${text}`;
            }
            if (level === 2){
                if (appBehaviour){
                    const layout = typeof appBehaviour === 'string'
                                ? appBehaviour || ''
                                : appBehaviour.layout || '';
                    if (layout === ADDON_LAYOUT){
                        return CONTENT_SECTION_ADDON;
                    } else {
                        return CONTENT_SECTION_SUBCATEGORY;
                    }
                } else {
                    return CONTENT_SECTION_SUBCATEGORY;
                }
            }
            if (level===3) {
                const parent = getNavDataNodeById(node.id_parent);
                const {app_behaviour}  = parent;
                appBehaviour = this.getAppBehaviourLayOut(app_behaviour);
                const layout = typeof appBehaviour === 'string'
                                ? appBehaviour || ''
                                : appBehaviour.layout || '';
                if (layout === ADDON_LAYOUT){
                    return CONTENT_SECTION_ADDON_SUBCATEGORY;
                } else {
                    return CONTENT_SECTION_SUBCATEGORY;
                }
            }
        } else {
            const { navbar:{from: {ribbon_title = ''} = {}} = {} } = store.getState() || {};
            if (ribbon_title.toLowerCase && ribbon_title.toLowerCase() === 'talentos'){
                return CONTENT_SECTION_SUBCATEGORY_TALEN;
            }
            return CONTENT_SECTION_VCARD;
        }
    }

    getContentType(data){
        const {type, is_series} = data;
        if (type === "live") return CONTENT_TYPE_TV;
        if (is_series) return CONTENT_TYPE_SERIE;
        return CONTENT_TYPE_MOVIE;
    }

    getDataSnUpAndDown() {
      return CardHelper.getDataSnUpAndDown(
        this.props.idsRibbonsUpAndDown,
        this.props.ribbonIndex,
        this.focusUp,
        this.focusDown
      );
    }

    handleMouseEnter(event) {
        SetValueElementMouseEnter.fire(event.currentTarget.id);
        const x = document.getElementById(event.currentTarget.id);
        window.SpatialNavigation.focus(x);
    }

    _handleLinkFocus() {
        CardHelper.focusHandler(this.focusHandler, this.data);
        this.onFocus();
    }

    _handleLinkKeyDown(e) {
        CardHelper.keyDownHandler(e, this.keyDownHandler, this.data);
    }

    _handlePlayerClick(e) {
        this.onClick(e);
    }

    _handlePlayerFocus() {
        CardHelper.focusHandler(this.focusHandler, this.data);
        this.onFocus();
    }

    _handlePlayerKeyDown(e) {
        CardHelper.keyDownHandler(e, this.keyDownHandler, this.data);
    }

    getLinkEnvelope(cardComponent) {
        const { type = '', ribbonId = '', ribbonIndex = 0, display = '', ribbonLength = 0, index = 0 } =  this.props;
        let className = '';
        if (this.props.ribbonIndex === 0) {
            className = 'elementopredeterminado';
        }
      const classDisplay = display && display === MODAL_TALENT_CONTENTS ? 'modal-talent-contents' : '';
      logger.debug('getLinkEnvelope:::::', type);
      const auxRibbonId = ribbonId.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().replace(/\s/g, '')
      const auxIdCard = auxRibbonId + '_' + type;
      const idPs = auxIdCard + '_link_' + this.id;
      const changeScale = !isActiveFocusDynamic() ? 'change-scale' : '';
      const idToFocusClass = type === "infinite" ? index : this.id;
      const focusClass = idToFocusClass <= ribbonLength ? this.focusClassName : "";
      const snUpAndDown = this.getDataSnUpAndDown();

        return (
            <FakeLink
                onClick={this.handleOnClick}
                typeRender={this.typeRender}
                id={this.props.idModalRecordserie ? 'link-' + this.props.idModalRecordserie : idPs}
                to={this.linkTo}
                className={'link-' + type + ' link ' + focusClass + ' ' + className + ' ' + this.zoomEfectClassName + ' ' + this.getClassNumberTop() + ' ' + classDisplay + ' focus_' + auxRibbonId + '_' + this.id + ' ' + changeScale}
                data-counter={this.state.positionInfinite}
                data-sn-up={snUpAndDown.focusUp}
                data-sn-down={snUpAndDown.focusDown}
                data-sn-right={this.focusRight}
                data-sn-left={this.focusLeft}
                onFocus={this._handleLinkFocus}
                onKeyDown={this._handleLinkKeyDown}
                onBlur={this.onBlur}
                onMouseEnter={this.handleMouseEnter}
            >
                {cardComponent}
            </FakeLink>
        );
    }

    getLinkPlayer(cardComponent) {
        let className = '';
        if (this.props.ribbonIndex === 0) {
            className = 'elementopredeterminado';
        }
        return (
            <FakeLink
                onClick={this._handlePlayerClick}
                typeRender={this.typeRender}
                id={'link-' + this.id}
                to={this.linkTo}
                className={'link-' + this.props.type + ' link ' + this.focusClassName + ' ' + className + ' ' + this.zoomEfectClassName + ' ' + this.getClassNumberTop()}
                data-counter={this.state.positionInfinite}
                data-sn-up={this.focusUp}
                data-sn-right={this.focusRight}
                data-sn-left={this.focusLeft}
                onFocus={this._handlePlayerFocus}
                onKeyDown={this._handlePlayerKeyDown}
                onBlur={this.onBlur}
                onMouseEnter={this.handleMouseEnter}
            >
                {cardComponent}
            </FakeLink>
        );
    }

    infiniteCardEnvelope(cardComponent) {
        const classDisplay = this.props.display && this.props.display === MODAL_TALENT_CONTENTS ? 'modal-talent-contents' : '';

        return (
            <div id={this.id} className={`${this.props.type} ${classDisplay}`} ref={this.onLoadHandler}>
                {cardComponent}
            </div>
        );
    }

    getClassNumberTop() {
        const index = this.props.data.index;
        if (index === 0) return 'numberTop-one';
        if (index === 9) return 'numberTop-ten';
        return 'container-img-number';
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.positionInfinite !== this.state.positionInfinite) {
            this.init(nextProps);
            this.setState({
                positionInfinite: nextProps.positionInfinite,
            });
        }
    }

    render() {
        let cardComponent;
        const classOutLineFocus = applyOutLineFocus()
        switch (this.props.type) {
            case HIGHLIGHT:
                cardComponent = (
                    <CardHighlight
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        classOutLineFocus = {classOutLineFocus}
                    />
                );
                break;
            case PREMIUM:
                cardComponent = (
                    <CardPremium
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        bookmark={this.props.bookmark}
                        hasPlayerIcon={true}
                        classOutLineFocus = {classOutLineFocus}
                    />
                );
                break;
            case TALENTS:
                cardComponent = (
                    <CardTalents
                        content_name ={this.props.content_name}
                        title={this.props.text_highlight}
                        subtitle={this.props.group_name}
                        label={this.props.label}
                        cover={this.props.image_highlight}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        classOutLineFocus = {classOutLineFocus}
                    />
                );
                break;
            case MUNDIALSOCCERMATCHER:

                cardComponent = (
                    <CardMatches
                        scheduledStartTimeUTC={changeDateToUserRegion(this.props.data.dateAndTimeInfo.scheduledStartTimeUTC)}
                        hpFlag={this.props.data.homeParticipant.nationality.images.flag}
                        hpCountryName= {this.props.data.homeParticipant.names.default}
                        apFlag= {this.props.data.awayParticipant.nationality.images.flag}
                        apCountryName = {this.props.data.awayParticipant.names.default}
                        currentPeriod = {this.props.data.state.currentPeriod}
                        scheduleStatus = {this.props.data.state.scheduleStatus}
                    />
                );
                break;
            case MUNDIALPLAYERS:
                cardComponent = (
                    <CardPlayer
                    image = {this.props.data.image}
                    name =  {this.props.data.name}
                    changeWeight={this.changeFontWeight}
                    />
                );
                break;
            case RECORDINGS:
                cardComponent = (
                    <CardRecording
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        data={this.props.data}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        showActions={this.state.showActions}
                        isRecentActivity={this.props.isRecentActivity}
                        isChannelRecordingBlocked={this.props.isChannelRecordingBlocked}
                    />
                );
                break;
            case MOREPOPULAR:
                cardComponent = (
                    <CardMorePopular
                        title={this.props.title}
                        label={this.props.label}
                        portrait={this.props.portrait}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        classOutLineFocus = {classOutLineFocus}
                    />
                );
                break;
            case MORETOP:
                cardComponent = (
                    <CardTop
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        imageNumbersTop={this.props.imageNumbersTop}
                        classNumberTop={this.getClassNumberTop()}
                        classOutLineFocus = {classOutLineFocus}
                    />
                );
                break;
            case LIVECHANNEL:
                cardComponent = (
                    <CardLiveChannel
                        id={this.id}
                        title={this.props.title}
                        cover={this.props.cover}
                        hasPlayerIcon={true}
                        data={this.props.data}
                        bookmark={this.props.bookmark}
                        showActions={this.state.showActions}
                    />
                );
                break;
            case INFINITE:
                this.typeRender =
                    Utils.isNotNullOrNotUndefined(this.props.live_enabled) &&
                    parseInt(this.props.live_enabled) === 1
                        ? 'a'
                        : null;
                cardComponent = (
                    <CardInfinite
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        provider={this.props.provider || null}
                        live_enabled={this.props.live_enabled || null}
                        classOutLineFocus = {classOutLineFocus}
                    />
                );
                break;
             case LASTVIEWEDCHANNELS:
                cardComponent = (
                    <CardLastViewedChannel
                        id={this.id}
                        channelNumber = {this.props.data.number}
                        title={this.props.data.name}
                        channelBlocked = {true} //Obtener el valor de algún lado
                        imageChannel={this.props.data.image}
                        imageEvent={this.props.data.event.image_base_horizontal}
                        data={this.props.data}
                        subtitle = {this.props.data.event.name}
                        startTime = {this.props.data.event.date_begin}
                        endTime = {this.props.data.event.date_end}
                        bookmark={this.props.bookmark}
                        showActions={this.state.showActions}
                    />
                );
                break;
            case LIVEEVENTSCHANNELS:
                cardComponent = (
                    <CardLiveEventsChannels
                        id={this.id}
                        channelNumber = {this.props.data.channelNumber}
                        title={this.props.data.title}
                        channelBlocked = {true} //Obtener el valor de algún lado
                        imageChannel={this.props.data.channelImage}
                        imageEvent={this.props.data.data.images.horizontal}
                        data={this.props.data}
                        subtitle = {this.props.data.subtitle}
                        startTime = {this.props.data.dateBegin}
                        endTime = {this.props.data.dateEnd }
                        bookmark={this.props.bookmark}
                        showActions={this.state.showActions}
                        group_id = {this.props.group_id}
                    />
                );
                break;
            case VOID:
                cardComponent = <CardVoid placeholder={this.props.placeholder}/>;
                break;
            case CLASSIC:
            default:
                const { ribbonType = '' } = this.props;
                cardComponent = (
                    <CardView
                        ribbonType={ribbonType}
                        id={this.id}
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        bookmark={this.props.bookmark}
                        showTitles={!this.props.hideTitles}
                        isRecentActivity={this.props.isRecentActivity}
                        badges={this.props.badges}
                        onDeleteAction={this.deleteAction}
                        showActions={this.state.showActions}
                        data={this.data}
                        classOutLineFocus = {classOutLineFocus}
                        isChannelBlocked={this.props.isChannelBlocked}
                    />
                );
        }
        cardComponent =
            this.props.type !== VOID ? this.getLinkEnvelope(cardComponent) : cardComponent;
        if (this.props.type === INFINITE) {
            cardComponent = this.infiniteCardEnvelope(cardComponent);
        }
        if(this.props.type ===  MUNDIALPLAYERS){
            cardComponent = this.getLinkPlayer(cardComponent);
        }
        return cardComponent;
    }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/CardNew/index.jsx